(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colleccion-con-carrusel"] && !Shopify.designMode) return;
  try {
    

(function () {

  function iniciarCarrusel(contenedor) {
    var pista = contenedor.querySelector('[data-pista]');
    var flechaPrev = contenedor.querySelector('[data-flecha="prev"]');
    var flechaNext = contenedor.querySelector('[data-flecha="next"]');

    if (!pista) return;

    var arrastrando = false;
    var inicioX = 0;
    var scrollInicio = 0;

    pista.addEventListener('mousedown', function (e) {
      arrastrando = false;
      inicioX = e.pageX;
      scrollInicio = pista.scrollLeft;
    });

    pista.addEventListener('mousemove', function (e) {
      if (e.buttons !== 1) return;
      if (Math.abs(e.pageX - inicioX) > 5) arrastrando = true;
    });

    pista.addEventListener('click', function (e) {
      if (arrastrando) return;
      var tarjeta = e.target.closest('.carrusel-coleccion__tarjeta');
      if (!tarjeta) return;
      var url = tarjeta.getAttribute('data-url');
      if (!url) return;
      window.location.href = url;
    });

    function calcularDesplazamiento() {
      var tarjeta = pista.querySelector('.carrusel-coleccion__tarjeta');
      if (!tarjeta) return 320;
      var gap = parseFloat(window.getComputedStyle(pista).gap) || 0;
      return tarjeta.offsetWidth + gap;
    }

    function actualizarFlechas() {
      if (!flechaPrev && !flechaNext) return;
      var scroll = Math.round(pista.scrollLeft);
      var maxScroll = pista.scrollWidth - pista.clientWidth;
      if (flechaPrev) {
        flechaPrev.setAttribute('aria-hidden', scroll <= 0 ? 'true' : 'false');
      }
      if (flechaNext) {
        flechaNext.setAttribute('aria-hidden', scroll >= maxScroll - 1 ? 'true' : 'false');
      }
    }

    function ajustarTopFlechas() {
      var imagen = pista.querySelector('.carrusel-coleccion__imagen-contenedor');
      if (!imagen) return;
      var top = imagen.offsetHeight / 2;
      [flechaPrev, flechaNext].forEach(function (flecha) {
        if (flecha) flecha.style.top = top + 'px';
      });
    }

    if (flechaPrev) {
      flechaPrev.addEventListener('click', function () {
        pista.scrollBy({ left: -calcularDesplazamiento(), behavior: 'smooth' });
      });
    }

    if (flechaNext) {
      flechaNext.addEventListener('click', function () {
        pista.scrollBy({ left: calcularDesplazamiento(), behavior: 'smooth' });
      });
    }

    pista.addEventListener('scroll', actualizarFlechas, { passive: true });

    var timerResize;
    window.addEventListener('resize', function () {
      clearTimeout(timerResize);
      timerResize = setTimeout(function () {
        actualizarFlechas();
        ajustarTopFlechas();
      }, 150);
    });

    actualizarFlechas();

    if (document.readyState === 'complete') {
      ajustarTopFlechas();
    } else {
      window.addEventListener('load', ajustarTopFlechas);
    }
  }

  function init() {
    document.querySelectorAll('.carrusel-coleccion[data-seccion]').forEach(iniciarCarrusel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["galeria-slider-enlace"] && !Shopify.designMode) return;
  try {
    

(function () {
  function iniciarGaleria(idPista) {
    var pista = document.getElementById(idPista);
    if (!pista) return;
    var wrapper = pista.closest('.gsl-wrapper');
    var btnAnterior = wrapper.querySelector('.gsl-flecha--anterior');
    var btnSiguiente = wrapper.querySelector('.gsl-flecha--siguiente');

    function obtenerDesplazamiento() {
      var el = pista.querySelector('.gsl-elemento');
      if (!el) return pista.clientWidth;
      var gap = parseFloat(window.getComputedStyle(pista).gap) || 0;
      return el.offsetWidth + gap;
    }

    function actualizarFlechas() {
      var enInicio = pista.scrollLeft <= 1;
      var enFinal = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
      if (btnAnterior) btnAnterior.classList.toggle('gsl-flecha--oculta', enInicio);
      if (btnSiguiente) btnSiguiente.classList.toggle('gsl-flecha--oculta', enFinal);
    }

    if (btnAnterior) {
      btnAnterior.addEventListener('click', function () {
        pista.scrollBy({ left: -obtenerDesplazamiento(), behavior: 'smooth' });
      });
    }

    if (btnSiguiente) {
      btnSiguiente.addEventListener('click', function () {
        pista.scrollBy({ left: obtenerDesplazamiento(), behavior: 'smooth' });
      });
    }

    pista.addEventListener('scroll', actualizarFlechas, { passive: true });
    window.addEventListener('resize', actualizarFlechas, { passive: true });
    actualizarFlechas();
  }

  function iniciarTodos() {
    document.querySelectorAll('[id^="gsl-pista-"]').forEach(function (pista) {
      iniciarGaleria(pista.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var pista = e.target.querySelector('[id^="gsl-pista-"]');
    if (pista) iniciarGaleria(pista.id);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var encabezado = document.getElementById('encabezado-personalizado');
  if (!encabezado) return;

  var umbral = parseInt(encabezado.dataset.umbral) || 50;
  var forzarFondo = encabezado.dataset.forzarFondo === 'true';
  var fondoClaroInicial = false;

  function esFondoClaro(elemento) {
    if (!elemento) return false;
    var bg = window.getComputedStyle(elemento).backgroundColor;
    var match = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (!match) return false;
    var r = parseInt(match[1]);
    var g = parseInt(match[2]);
    var b = parseInt(match[3]);
    var luminosidad = (r * 299 + g * 587 + b * 114) / 1000;
    return luminosidad > 200;
  }

  function tieneImagenFondo(elemento) {
    if (!elemento) return false;
    var bg = window.getComputedStyle(elemento).backgroundImage;
    return bg && bg !== 'none';
  }

  function detectarFondoInicial() {
    if (forzarFondo) return;

    var alturaHeader = encabezado.offsetHeight || 70;
    var elementoBajo = document.elementFromPoint(window.innerWidth / 2, alturaHeader + 2);

    if (!elementoBajo || elementoBajo === encabezado) return;

    var seccionPrincipal = elementoBajo.closest('section, .shopify-section, main') || elementoBajo;

    if (tieneImagenFondo(seccionPrincipal) || tieneImagenFondo(elementoBajo)) {
      fondoClaroInicial = false;
      return;
    }

    var candidatos = [elementoBajo, seccionPrincipal, elementoBajo.parentElement];
    for (var i = 0; i < candidatos.length; i++) {
      if (candidatos[i] && esFondoClaro(candidatos[i])) {
        fondoClaroInicial = true;
        encabezado.classList.add('encabezado-icono-oscuro');
        return;
      }
    }
  }

  function actualizarEstado() {
    if (forzarFondo) return;

    var scrolled = window.scrollY >= umbral;

    if (scrolled) {
      encabezado.classList.add('encabezado-con-fondo');
      encabezado.classList.remove('encabezado-icono-oscuro');
    } else {
      encabezado.classList.remove('encabezado-con-fondo');
      if (fondoClaroInicial) {
        encabezado.classList.add('encabezado-icono-oscuro');
      } else {
        encabezado.classList.remove('encabezado-icono-oscuro');
      }
    }
  }

  window.addEventListener('scroll', actualizarEstado, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      detectarFondoInicial();
      actualizarEstado();
    });
  } else {
    detectarFondoInicial();
    actualizarEstado();
  }

  var panelBusqueda = document.getElementById('enc-panel-busqueda');
  var btnBuscar = document.getElementById('enc-buscar-btn');
  var btnCerrarBusqueda = document.getElementById('enc-busqueda-cerrar');
  var inputBusqueda = document.getElementById('enc-busqueda-input');

  function abrirBusqueda() {
    panelBusqueda.classList.add('enc-panel-busqueda--abierto');
    panelBusqueda.setAttribute('aria-hidden', 'false');
    btnBuscar.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    inputBusqueda.focus();
  }

  function cerrarBusqueda() {
    panelBusqueda.classList.remove('enc-panel-busqueda--abierto');
    panelBusqueda.setAttribute('aria-hidden', 'true');
    btnBuscar.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    var sg = document.getElementById('enc-busqueda-sugerencias');
    if (sg) { sg.classList.remove('enc-busqueda-sugerencias--visible'); sg.innerHTML = ''; }
    if (inputBusqueda) inputBusqueda.value = '';
  }

  if (btnBuscar) btnBuscar.addEventListener('click', abrirBusqueda);
  if (btnCerrarBusqueda) btnCerrarBusqueda.addEventListener('click', cerrarBusqueda);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      cerrarBusqueda();
      cerrarDropdown();
      cerrarDrawer();
    }
  });

  var btnHamburguesa = document.getElementById('enc-ham-btn');
  var drawer = document.getElementById('enc-drawer');
  var btnCerrarDrawer = document.getElementById('enc-drawer-cerrar');
  var velo = document.getElementById('enc-velo');

  function abrirDrawer() {
    drawer.classList.add('enc-drawer--abierto');
    drawer.setAttribute('aria-hidden', 'false');
    velo.classList.add('enc-velo--visible');
    velo.setAttribute('aria-hidden', 'false');
    btnHamburguesa.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function cerrarDrawer() {
    if (!drawer) return;
    drawer.classList.remove('enc-drawer--abierto');
    drawer.setAttribute('aria-hidden', 'true');
    velo.classList.remove('enc-velo--visible');
    velo.setAttribute('aria-hidden', 'true');
    if (btnHamburguesa) btnHamburguesa.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    drawer.querySelectorAll('.enc-drawer-submenu--abierto').forEach(function(s) {
      s.classList.remove('enc-drawer-submenu--abierto');
      s.setAttribute('aria-hidden', 'true');
    });
    drawer.querySelectorAll('.enc-drawer-flecha[aria-expanded="true"]').forEach(function(b) {
      b.setAttribute('aria-expanded', 'false');
    });
  }

  if (btnHamburguesa) btnHamburguesa.addEventListener('click', abrirDrawer);
  if (btnCerrarDrawer) btnCerrarDrawer.addEventListener('click', cerrarDrawer);
  if (velo) velo.addEventListener('click', function () {
    cerrarDrawer();
    cerrarDropdown();
  });

  var shopBtn = document.getElementById('enc-shop-btn');
  var dropdown = document.getElementById('enc-dropdown');

  function abrirDropdown() {
    if (!dropdown) return;
    dropdown.classList.add('enc-dropdown--visible');
    dropdown.setAttribute('aria-hidden', 'false');
    shopBtn.setAttribute('aria-expanded', 'true');
  }

  function cerrarDropdown() {
    if (!dropdown) return;
    dropdown.classList.remove('enc-dropdown--visible');
    dropdown.setAttribute('aria-hidden', 'true');
    if (shopBtn) shopBtn.setAttribute('aria-expanded', 'false');
    var ip = document.getElementById('enc-dropdown-imagenes');
    if (ip) ip.classList.remove('enc-imagenes--ocultas');
    var im = document.getElementById('enc-dropdown-imagen-marca');
    if (im) im.classList.remove('enc-dropdown-imagen-marca--visible');
    dropdown.querySelectorAll('.enc-submenu-panel').forEach(function(p) {
      p.classList.remove('enc-submenu-panel--visible');
    });
  }

  if (shopBtn && dropdown) {
    shopBtn.addEventListener('mouseenter', abrirDropdown);
    encabezado.addEventListener('mouseleave', cerrarDropdown);
    dropdown.addEventListener('mouseenter', function () {
      dropdown.classList.add('enc-dropdown--visible');
    });
    shopBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var abierto = dropdown.classList.contains('enc-dropdown--visible');
      if (abierto) {
        cerrarDropdown();
      } else {
        abrirDropdown();
      }
    });
    document.addEventListener('click', function (e) {
      if (!encabezado.contains(e.target)) {
        cerrarDropdown();
      }
    });
  }
  // Búsqueda predictiva
  var sugerenciasPanel = document.getElementById('enc-busqueda-sugerencias');
  var timeoutPredict = null;
  var indiceActivo = -1;

  function formatearPrecio(cents) {
    return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(cents / 100);
  }

  function resaltarTexto(texto, query) {
    var re = new RegExp('(' + query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
    return texto.replace(re, '<mark>$1</mark>');
  }

  function renderizarSugerencias(productos, query) {
    if (!sugerenciasPanel) return;
    indiceActivo = -1;
    if (!productos || productos.length === 0) {
      sugerenciasPanel.innerHTML = '<p class="enc-sugerencia-vacio">Sin resultados para "' + query + '"</p>';
      sugerenciasPanel.classList.add('enc-busqueda-sugerencias--visible');
      return;
    }
    var html = '';
    productos.forEach(function(p) {
      var img = p.featured_image ? '<img src="' + p.featured_image.url + '&width=120" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '';
      var nombre = resaltarTexto(p.title, query);
      html += '<a href="' + p.url + '" class="enc-sugerencia-item" role="option" tabindex="-1">'
        + '<div class="enc-sugerencia-img">' + img + '</div>'
        + '<div class="enc-sugerencia-info">'
        + '<span class="enc-sugerencia-nombre">' + nombre + '</span>'
        + '</div></a>';
    });
    sugerenciasPanel.innerHTML = html;
    sugerenciasPanel.classList.add('enc-busqueda-sugerencias--visible');
  }

  function ocultarSugerencias() {
    if (!sugerenciasPanel) return;
    sugerenciasPanel.classList.remove('enc-busqueda-sugerencias--visible');
    sugerenciasPanel.innerHTML = '';
    indiceActivo = -1;
  }

  if (inputBusqueda && sugerenciasPanel) {
    inputBusqueda.addEventListener('input', function() {
      clearTimeout(timeoutPredict);
      var q = inputBusqueda.value.trim();
      if (q.length < 2) { ocultarSugerencias(); return; }
      timeoutPredict = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var prods = data.resources && data.resources.results && data.resources.results.products;
            renderizarSugerencias(prods || [], q);
          })
          .catch(ocultarSugerencias);
      }, 220);
    });

    inputBusqueda.addEventListener('keydown', function(e) {
      var items = sugerenciasPanel.querySelectorAll('.enc-sugerencia-item');
      if (!items.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        indiceActivo = Math.min(indiceActivo + 1, items.length - 1);
        items.forEach(function(i, idx) { i.classList.toggle('enc-sugerencia-item--activo', idx === indiceActivo); });
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        indiceActivo = Math.max(indiceActivo - 1, -1);
        items.forEach(function(i, idx) { i.classList.toggle('enc-sugerencia-item--activo', idx === indiceActivo); });
      } else if (e.key === 'Enter' && indiceActivo >= 0) {
        e.preventDefault();
        items[indiceActivo].click();
      }
    });

    document.addEventListener('click', function(e) {
      if (panelBusqueda && !panelBusqueda.contains(e.target)) {
        ocultarSugerencias();
      }
    });
  }

  document.querySelectorAll('.enc-drawer-flecha').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.enc-drawer-item');
      var submenu = item.querySelector('.enc-drawer-submenu');
      var abierto = btn.getAttribute('aria-expanded') === 'true';
      if (abierto) {
        btn.setAttribute('aria-expanded', 'false');
        submenu.classList.remove('enc-drawer-submenu--abierto');
        submenu.setAttribute('aria-hidden', 'true');
      } else {
        btn.setAttribute('aria-expanded', 'true');
        submenu.classList.add('enc-drawer-submenu--abierto');
        submenu.setAttribute('aria-hidden', 'false');
      }
    });
  });

  var imagenesPanel = document.getElementById('enc-dropdown-imagenes');
  var imagenMarcaPanel = document.getElementById('enc-dropdown-imagen-marca');
  if (imagenesPanel) {
    encabezado.querySelectorAll('.enc-dropdown-link--parent').forEach(function(link) {
      link.addEventListener('mouseenter', function() {
        imagenesPanel.classList.add('enc-imagenes--ocultas');
        if (imagenMarcaPanel) imagenMarcaPanel.classList.remove('enc-dropdown-imagen-marca--visible');
        encabezado.querySelectorAll('.enc-submenu-panel').forEach(function(p) {
          p.classList.remove('enc-submenu-panel--visible');
        });
        var panel = document.getElementById(link.dataset.submenu);
        if (panel) panel.classList.add('enc-submenu-panel--visible');
      });
    });

    encabezado.querySelectorAll('.enc-dropdown-link:not(.enc-dropdown-link--parent)').forEach(function(link) {
      link.addEventListener('mouseenter', function() {
        encabezado.querySelectorAll('.enc-submenu-panel').forEach(function(p) {
          p.classList.remove('enc-submenu-panel--visible');
        });
        if (imagenMarcaPanel && link.classList.contains('enc-dropdown-link--marca')) {
          imagenesPanel.classList.add('enc-imagenes--ocultas');
          imagenMarcaPanel.classList.add('enc-dropdown-imagen-marca--visible');
        } else {
          imagenesPanel.classList.remove('enc-imagenes--ocultas');
          if (imagenMarcaPanel) imagenMarcaPanel.classList.remove('enc-dropdown-imagen-marca--visible');
        }
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
